export type conversationTypes = 'Whatsapp' | 'Telegram';
